import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getInteractionsType = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/interactions_type', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getInteractionType = id => {
  return api.http.get(`/interactions_type/${id}`)
}

export const searchInteractionsType = term => {
  return api.http.get('/interactions_type/select_search', {
    params: {
      term
    }
  })
}

export const getSelectInteractionsType = (term, callback) => {
  searchInteractionsType(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteInteractionType = id => {
  return api.http.delete(`/interactions_type/${id}`)
}

export const restoreInteractionType = id => {
  return api.http.put(`/interactions_type/${id}/restore`)
}

export const editInteractionType = interactionType => {
  return api.http.put(`/interactions_type/${interactionType._id}`, interactionType)
}

export const addInteractionType = interactionType => {
  return api.http.post('/interactions_type', interactionType)
}

export const getLogs = id => {
  return api.http.get(`/interactions_type/${id}/logs`)
}



// WEBPACK FOOTER //
// ./src/api/interactionsType.js